import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Marquee from 'react-fast-marquee';
import { Coffee, QrCode, LightningA, ChartLineUp, Heart, ShieldCheck, CurrencyCircleDollar, ArrowRight, Sparkle, Broadcast, VideoCamera, Timer, ListNumbers, ChartBar, CheckSquare, Users, SpeakerHigh } from '@phosphor-icons/react';
import { usePlatform } from '../context/PlatformContext';

const creatorAvatar = "https://images.unsplash.com/photo-1634002470139-eb8afa9e103d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwzfHxpbmRvbmVzaWFuJTIwY29udGVudCUyMGNyZWF0b3IlMjBzdHJlYW1lciUyMHBvZGNhc3QlMjBoYXBweXxlbnwwfHx8fDE3NzY3NTMzNzR8MA&ixlib=rb-4.1.0&q=85";

export default function Landing() {
  const { platformConfig } = usePlatform();

  return (
    <div className="min-h-screen bg-background">
      <Navbar />

      {/* HERO */}
      <section className="border-b-2 border-foreground relative overflow-hidden">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-16 md:py-24 grid md:grid-cols-5 gap-10 items-center">
          <div className="md:col-span-3 animate-pop-in">
            <div className="inline-flex items-center gap-2 border-2 border-foreground bg-secondary px-3 py-1.5 mb-6 shadow-brutal-sm">
              <Sparkle size={14} weight="fill" />
              <span className="text-xs font-bold uppercase tracking-widest">Platform traktiran #1 di Indonesia</span>
            </div>
            <h1 className="font-display font-bold text-5xl md:text-7xl lg:text-8xl leading-[0.9] tracking-tight mb-6">
              TERIMA <span className="bg-primary text-white px-2 border-2 border-foreground shadow-brutal inline-block -rotate-1">TRAKTIRAN</span> DARI KARYAMU.
            </h1>
            <p className="text-lg md:text-xl leading-relaxed max-w-xl text-foreground/80 mb-8">
              Bikin halaman traktiran kamu sendiri. Dukungan dari audiens langsung masuk lewat QRIS & E-Wallet.
              Tanpa setup ribet, tanpa biaya bulanan.
            </p>
            <div className="flex flex-wrap gap-4">
              <Link to="/register" className="inline-flex items-center gap-2 border-2 border-foreground bg-primary text-white px-6 py-4 font-bold uppercase tracking-wide shadow-brutal hover:shadow-brutal-sm hover:translate-x-[2px] hover:translate-y-[2px] active:shadow-none active:translate-x-[4px] active:translate-y-[4px] transition-all">
                Mulai Gratis <ArrowRight size={18} weight="bold" />
              </Link>
              <Link to="/u/hasbi" className="inline-flex items-center gap-2 border-2 border-foreground bg-white px-6 py-4 font-bold uppercase tracking-wide shadow-brutal hover:shadow-brutal-sm hover:translate-x-[2px] hover:translate-y-[2px] transition-all">
                Lihat Demo
              </Link>
            </div>
            <div className="mt-8 flex flex-wrap items-center gap-6 text-sm text-muted-foreground">
              <div className="flex items-center gap-2"><ShieldCheck size={18} weight="bold" /> 100% Aman</div>
              <div className="flex items-center gap-2"><LightningA size={18} weight="bold" /> Cair cepat</div>
              <div className="flex items-center gap-2"><CurrencyCircleDollar size={18} weight="bold" /> Fee 3%</div>
            </div>
          </div>

          {/* MOCK profile card */}
          <div className="md:col-span-2 relative">
            <div className="border-2 border-foreground bg-white shadow-brutal-xl p-6 rotate-2 hover:rotate-0 transition-all duration-300">
              <div className="flex items-center gap-4 mb-4">
                <img src={creatorAvatar} alt="Creator" className="w-16 h-16 border-2 border-foreground object-cover" />
                <div>
                  <p className="font-display font-bold text-lg">Nadia Rizqi</p>
                  <p className="text-sm text-muted-foreground">@nadiakreasi</p>
                </div>
              </div>
              <p className="text-sm mb-4">Guru bahasa & kreator buku anak. Traktir aku kopi biar terus berkarya! ✨</p>
              <div className="space-y-2 mb-4">
                <div className="flex items-center justify-between border-2 border-foreground p-3 bg-secondary shadow-brutal-sm">
                  <div className="flex items-center gap-2"><span className="text-xl">☕</span><span className="font-bold">1 Kopi</span></div>
                  <span className="font-bold">Rp 10.000</span>
                </div>
                <div className="flex items-center justify-between border-2 border-foreground p-3 bg-accent shadow-brutal-sm">
                  <div className="flex items-center gap-2"><span className="text-xl">🍜</span><span className="font-bold">1 Mie</span></div>
                  <span className="font-bold">Rp 25.000</span>
                </div>
              </div>
              <button className="w-full border-2 border-foreground bg-primary text-white py-3 font-bold uppercase tracking-wide shadow-brutal" disabled>
                Traktir Sekarang
              </button>
            </div>
          </div>
        </div>

        {/* Marquee */}
        <div className="border-t-2 border-foreground bg-foreground text-background py-3">
          <Marquee speed={40} gradient={false}>
            <span className="font-display font-bold text-xl uppercase tracking-wider mx-8">★ QRIS Ready</span>
            <span className="font-display font-bold text-xl uppercase tracking-wider mx-8">★ Overlay Streaming OBS</span>
            <span className="font-display font-bold text-xl uppercase tracking-wider mx-8">★ E-Wallet Support</span>
            <span className="font-display font-bold text-xl uppercase tracking-wider mx-8">★ Fee Transparan 3%</span>
            <span className="font-display font-bold text-xl uppercase tracking-wider mx-8">★ Media Share</span>
            <span className="font-display font-bold text-xl uppercase tracking-wider mx-8">★ Tanpa Biaya Bulanan</span>
            <span className="font-display font-bold text-xl uppercase tracking-wider mx-8">★ Alert Box & Leaderboard</span>
            <span className="font-display font-bold text-xl uppercase tracking-wider mx-8">★ Monetisasi Karya Digital</span>
          </Marquee>
        </div>
      </section>

      {/* FEATURES — Bento */}
      <section className="max-w-7xl mx-auto px-4 md:px-8 py-16 md:py-24 border-b-2 border-foreground">
        <div className="mb-12 max-w-3xl">
          <p className="text-xs uppercase tracking-[0.3em] font-bold mb-3">Fitur Lengkap</p>
          <h2 className="font-display text-4xl md:text-6xl font-bold tracking-tight">
            Semua yang kamu butuhin<br />buat <span className="bg-accent px-2 border-2 border-foreground">monetisasi konten.</span>
          </h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          <div className="sm:col-span-2 lg:col-span-2 border-2 border-foreground bg-secondary p-8 shadow-brutal-md">
            <QrCode size={48} weight="duotone" />
            <h3 className="font-display text-2xl md:text-3xl font-bold mt-4 mb-2">Checkout QRIS Instan</h3>
            <p className="text-foreground/80">Audiens scan QR, kamu langsung dapat notifikasi. Terintegrasi penuh dengan Pakasir Payment Gateway.</p>
          </div>

          <div className="border-2 border-foreground bg-accent p-8 shadow-brutal-md">
            <Heart size={40} weight="duotone" />
            <h3 className="font-display text-xl font-bold mt-4 mb-2">Supporter Feed</h3>
            <p className="text-foreground/80 text-sm">Daftar pendukung update otomatis. Transparan, membangun hype, dan bikin supporter lain ikutan.</p>
          </div>

          <div className="border-2 border-foreground bg-foreground text-background p-8 shadow-brutal-md">
            <ShieldCheck size={40} weight="duotone" className="text-primary" />
            <div className="flex items-center gap-2 mt-4 mb-2">
              <h3 className="font-display text-xl font-bold">AI Protection</h3>
              <span className="bg-primary text-white text-[9px] px-1.5 py-0.5 font-bold uppercase">Anti-Judol</span>
            </div>
            <p className="opacity-80 text-sm">Filter cerdas yang melindungi reputasi kreator dari spam judi online, kata kasar, link & nomor spam 24/7.</p>
          </div>

          <div className="border-2 border-foreground bg-primary text-white p-8 shadow-brutal-md">
            <p className="font-display text-4xl font-bold leading-none">🎯</p>
            <h3 className="font-display text-xl font-bold mt-4 mb-2">Target Pendanaan</h3>
            <p className="opacity-90 text-sm">Set goals, tampilkan progress bar ke audiens.</p>
          </div>

          <div className="border-2 border-foreground bg-white p-8 shadow-brutal-md">
            <CurrencyCircleDollar size={40} weight="duotone" />
            <h3 className="font-display text-xl font-bold mt-4 mb-2">Penarikan Dana</h3>
            <p className="text-foreground/80 text-sm">Cairkan saldo ke rekening bank lokal favoritmu. Minimal Rp 10.000.</p>
          </div>
        </div>
      </section>

      {/* OVERLAY STREAMING SECTION — NEW */}
      <section className="border-b-2 border-foreground bg-foreground text-background">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-16 md:py-24">
          <div className="grid md:grid-cols-2 gap-12 items-center mb-16">
            <div>
              <div className="inline-flex items-center gap-2 border-2 border-background/30 bg-primary px-3 py-1.5 mb-6 shadow-brutal-sm">
                <Broadcast size={14} weight="bold" />
                <span className="text-xs font-bold uppercase tracking-widest text-white">Fitur Baru!</span>
              </div>
              <h2 className="font-display text-4xl md:text-6xl font-bold tracking-tight mb-6">
                OVERLAY <span className="text-primary">LIVE STREAMING</span>
              </h2>
              <p className="text-lg opacity-80 leading-relaxed mb-8">
                Tampilkan donasi langsung di layar OBS/Streamlabs. Alert box, leaderboard, media share, voting, dan lainnya — semua real-time.
              </p>
              <Link to="/register" className="inline-flex items-center gap-2 border-2 border-background bg-primary text-white px-6 py-3 font-bold uppercase tracking-wide shadow-[4px_4px_0px_0px_#FFF9E6] hover:translate-x-[2px] hover:translate-y-[2px] transition-all">
                Coba Sekarang <ArrowRight size={16} weight="bold" />
              </Link>
            </div>
            <div>
              <img src="/overlay-feature.webp" alt="Overlay Live Streaming" className="w-full border-2 border-background/20 shadow-brutal-xl" />
            </div>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {[
              { icon: Broadcast, name: 'Alert Box + TTS', desc: 'Notifikasi animasi + suara + baca pesan otomatis' },
              { icon: VideoCamera, name: 'Media Share', desc: 'Donatur kirim video YouTube atau TikTok untuk diputar' },
              { icon: ChartBar, name: 'Leaderboard', desc: 'Peringkat donatur harian/mingguan/bulanan' },
              { icon: Timer, name: 'Subathon Timer', desc: 'Timer bertambah otomatis tiap donasi' },
              { icon: ListNumbers, name: 'Running Text', desc: 'Ticker nama donatur berjalan di layar' },
              { icon: CheckSquare, name: 'Voting', desc: 'Polling interaktif lewat pesan donasi' },
              { icon: QrCode, name: 'QR Code', desc: 'QR custom dengan logo untuk scan langsung dari stream' },
              { icon: SpeakerHigh, name: 'Text-to-Speech', desc: 'Pesan donasi dibacakan otomatis (ID/EN/JP)' },
              { icon: CurrencyCircleDollar, name: 'Donation Goal', desc: 'Progress bar target pendanaan' },
              { icon: ShieldCheck, name: 'Sensor Otomatis', desc: 'Filter kata kasar di pesan overlay' },
            ].map((f, i) => (
              <div key={i} className="border-2 border-background/20 bg-background/5 p-5 hover:bg-background/10 transition-colors">
                <f.icon size={28} weight="duotone" className="text-primary mb-3" />
                <h4 className="font-bold text-sm mb-1">{f.name}</h4>
                <p className="text-xs opacity-60">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* AI PROTECTION SYSTEM SECTION */}
      <section className="border-b-2 border-foreground bg-gradient-to-br from-primary/5 via-background to-accent/10">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-16 md:py-24">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <div className="inline-flex items-center gap-2 border-2 border-foreground bg-primary text-white px-3 py-1.5 mb-6 shadow-brutal-sm">
                <ShieldCheck size={14} weight="bold" />
                <span className="text-xs font-bold uppercase tracking-widest">Fitur Utama</span>
              </div>
              <h2 className="font-display text-4xl md:text-6xl font-bold tracking-tight mb-6">
                AI PROTECTION <span className="text-primary">SYSTEM</span>
              </h2>
              <p className="text-lg text-foreground/80 leading-relaxed mb-8">
                Sistem keamanan pintar yang melindungi kreator dari donasi berisi promosi <strong>Judi Online (Judol)</strong>, konten dewasa, dan pesan toksik. Bekerja <strong>24/7 otomatis</strong> dengan teknologi deteksi canggih.
              </p>
              <div className="flex flex-wrap gap-3 mb-8">
                <span className="border-2 border-foreground bg-destructive text-white px-3 py-1.5 text-xs font-bold uppercase shadow-brutal-sm">Anti Judol</span>
                <span className="border-2 border-foreground bg-foreground text-background px-3 py-1.5 text-xs font-bold uppercase shadow-brutal-sm">Anti Toxic</span>
                <span className="border-2 border-foreground bg-secondary px-3 py-1.5 text-xs font-bold uppercase shadow-brutal-sm">Anti Link Spam</span>
                <span className="border-2 border-foreground bg-accent px-3 py-1.5 text-xs font-bold uppercase shadow-brutal-sm">Anti Nomor Spam</span>
              </div>
              <Link to="/register" className="inline-flex items-center gap-2 border-2 border-foreground bg-primary text-white px-6 py-3 font-bold uppercase tracking-wide shadow-brutal hover:shadow-brutal-sm hover:translate-x-[2px] hover:translate-y-[2px] transition-all">
                Aktifkan Sekarang <ArrowRight size={16} weight="bold" />
              </Link>
            </div>
            <div className="space-y-4">
              {[
                { emoji: '🛡️', title: 'Anti Judi Online (Judol)', desc: 'Deteksi 100+ kata kunci gambling termasuk nama provider (Pragmatic, PG Soft), nama game (Sweet Bonanza, Gates of Olympus), dan frasa promosi (gacor, maxwin, scatter).', badge: '100+ keyword' },
                { emoji: '🧠', title: 'Deteksi Leetspeak & Trik', desc: 'Mengenali variasi kreatif spammer seperti "sl0t", "g4c0r", "m4xw1n", huruf Cyrillic, dan penyisipan simbol "s.l.o.t".', badge: 'AI Powered' },
                { emoji: '🔗', title: 'Anti Link & URL Spam', desc: 'Otomatis mendeteksi dan menyensor URL yang mengarah ke situs judi, togel, casino, dan taruhan online.', badge: 'Real-time' },
                { emoji: '📱', title: 'Anti Nomor Spam', desc: 'Menyensor nomor HP/WhatsApp format Indonesia yang biasa digunakan untuk merekrut korban judi online.', badge: '24/7' },
              ].map((f, i) => (
                <div key={i} className="border-2 border-foreground bg-white p-5 shadow-brutal-sm hover:shadow-none hover:translate-x-[2px] hover:translate-y-[2px] transition-all">
                  <div className="flex items-start gap-4">
                    <span className="text-3xl shrink-0">{f.emoji}</span>
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center gap-2 mb-1 flex-wrap">
                        <h4 className="font-bold text-sm">{f.title}</h4>
                        <span className="bg-primary/10 text-primary border border-primary/30 px-1.5 py-0.5 text-[9px] font-bold uppercase">{f.badge}</span>
                      </div>
                      <p className="text-xs text-muted-foreground leading-relaxed">{f.desc}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section className="max-w-7xl mx-auto px-4 md:px-8 py-16 md:py-24 border-b-2 border-foreground">
        <p className="text-xs uppercase tracking-[0.3em] font-bold mb-3">Cara Kerja</p>
        <h2 className="font-display text-4xl md:text-6xl font-bold tracking-tight mb-12">3 Langkah. Selesai.</h2>
        <div className="grid md:grid-cols-3 gap-6">
          {[
            { n: '01', t: 'Daftar & Personalisasi', d: 'Buat akun dalam hitungan detik, atur username unik, dan upload foto profil.' },
            { n: '02', t: 'Buat Link Donasi QRIS', d: 'Dapatkan link profil kustom (traktirkan.com/u/username) untuk dibagikan di sosial media.' },
            { n: '03', t: 'Terima Dukungan Dana', d: 'Terima traktiran real-time dari audiens. Cairkan saldo ke rekening kapan saja.' },
          ].map((s, i) => (
            <div key={i} className="border-2 border-foreground bg-white p-8 shadow-brutal-md">
              <p className="font-display text-5xl font-bold text-primary">{s.n}</p>
              <h3 className="font-display text-2xl font-bold mt-4 mb-2">{s.t}</h3>
              <p className="text-foreground/80">{s.d}</p>
            </div>
          ))}
        </div>
      </section>

      {/* COMMUNITY / NICHE */}
      <section className="max-w-7xl mx-auto px-4 md:px-8 py-16 md:py-24 border-b-2 border-foreground">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <img src="/monetization-solution.webp" alt="Solusi Monetisasi Kreator" className="w-full border-2 border-foreground shadow-brutal-md" />
          </div>
          <div>
            <p className="text-xs uppercase tracking-[0.3em] font-bold mb-3">Target Audiens</p>
            <h2 className="font-display text-4xl md:text-5xl font-bold tracking-tight mb-8">Solusi Monetisasi Kreator.</h2>
            <div className="grid grid-cols-2 gap-4">
              {[
                { emoji: '🎮', title: 'Streamer Gaming', desc: 'Platform donasi streamer Indonesia terbaik.' },
                { emoji: '✍️', title: 'Penulis & Blogger', desc: 'Dukungan dana untuk penulis artikel & novel.' },
                { emoji: '🎨', title: 'Ilustrator', desc: 'Platform traktir kopi untuk ilustrator digital.' },
                { emoji: '💻', title: 'Developer', desc: 'Terima donasi untuk proyek open source.' },
                { emoji: '🎙️', title: 'Podcaster', desc: 'Monetisasi podcast & konten audio.' },
                { emoji: '🎵', title: 'Musisi', desc: 'Dukungan untuk karya musik independen.' },
              ].map((c, i) => (
                <div key={i} className="border-2 border-foreground bg-white p-4 shadow-brutal-sm">
                  <div className="text-3xl mb-2">{c.emoji}</div>
                  <h4 className="font-bold text-sm uppercase mb-1">{c.title}</h4>
                  <p className="text-xs text-muted-foreground">{c.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="mt-12 text-center">
          <p className="text-sm font-bold text-foreground/70 italic">
            "Alternatif Trakteer & Saweria dengan fitur overlay streaming lengkap."
          </p>
        </div>
      </section>

      {/* MASCOT SECTION */}
      <section className="max-w-7xl mx-auto px-4 md:px-8 py-16 md:py-24 border-b-2 border-foreground bg-primary/5">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="order-2 md:order-1">
            <p className="text-xs uppercase tracking-[0.3em] font-bold mb-3">Kenalan Yuk!</p>
            <h2 className="font-display text-4xl md:text-5xl font-bold tracking-tight mb-8">Si Trakti: Teman Setia Kreator.</h2>
            <div className="space-y-6">
              <p className="text-lg leading-relaxed text-foreground/80">
                Trakti adalah maskot resmi Traktirkan yang melambangkan semangat gotong royong dan apresiasi terhadap karya kreatif.
              </p>
              <ul className="space-y-4">
                {[
                  { t: 'Ramah & Ceria', d: 'Selalu siap menyambut traktiran dengan animasi yang menggemaskan.' },
                  { t: 'Siaga 24 Jam', d: 'Membantu memantau donasi yang masuk agar tidak ada yang terlewat.' },
                  { t: 'Ikon Apresiasi', d: 'Simbol bahwa setiap karya sekecil apapun layak mendapatkan traktiran.' },
                ].map((item, i) => (
                  <li key={i} className="flex gap-4">
                    <div className="w-6 h-6 shrink-0 border-2 border-foreground bg-white shadow-[2px_2px_0px_0px_#09090B] flex items-center justify-center font-bold text-xs">
                      {i+1}
                    </div>
                    <div>
                      <h4 className="font-bold">{item.t}</h4>
                      <p className="text-sm text-muted-foreground">{item.d}</p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="order-1 md:order-2">
            <div className="border-4 border-foreground bg-white shadow-brutal-xl overflow-hidden p-6 rotate-3">
              <img src="/mascot.webp" alt="Mascot Trakti" className="w-full h-auto" />
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="max-w-7xl mx-auto px-4 md:px-8 py-16 md:py-24">
        <div className="border-2 border-foreground bg-foreground text-background shadow-brutal-xl p-10 md:p-16 grainy">
          <h2 className="font-display text-4xl md:text-6xl font-bold tracking-tight mb-4">
            Udah siap dapet traktiran?
          </h2>
          <p className="text-lg md:text-xl opacity-80 mb-8 max-w-2xl">
            Gabung sekarang. Gratis selamanya. Fee cuma 3% dari tiap traktiran.
          </p>
          <Link to="/register" className="inline-flex items-center gap-2 border-2 border-background bg-primary text-white px-8 py-4 font-bold uppercase tracking-wide shadow-[6px_6px_0px_0px_#FFF9E6] hover:translate-x-[3px] hover:translate-y-[3px] hover:shadow-[3px_3px_0px_0px_#FFF9E6] active:shadow-none active:translate-x-[6px] active:translate-y-[6px] transition-all">
            Buat Halaman Traktiranku <ArrowRight size={20} weight="bold" />
          </Link>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="border-t-2 border-foreground py-12 bg-white/50">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-10">
            <div>
              <div className="flex items-center mb-4">
                <img src="/logo-header.png" alt="Traktirkan" className="h-12 w-auto object-contain" />
              </div>
              <p className="text-xs text-muted-foreground mb-4">Platform traktiran kreator Indonesia. Terima donasi via QRIS & E-Wallet.</p>
              <div className="space-y-1">
                <p className="text-[10px] font-bold uppercase tracking-wider">Hubungi Kami:</p>
                <p className="text-xs font-mono"><a href="mailto:traktirkan@gmail.com" className="hover:text-primary">traktirkan@gmail.com</a></p>
                {platformConfig?.whatsapp_url && (
                  <p className="text-xs font-mono"><a href={platformConfig.whatsapp_url} target="_blank" rel="noreferrer" className="hover:text-primary">WhatsApp Bantuan</a></p>
                )}
              </div>
            </div>
            <div>
              <h5 className="font-bold text-xs uppercase tracking-widest mb-3">Produk</h5>
              <ul className="space-y-2 text-sm text-muted-foreground">
                <li><Link to="/register" className="hover:text-primary transition-colors">Daftar Gratis</Link></li>
                <li><Link to="/panduan" className="hover:text-primary transition-colors">Panduan Pengguna</Link></li>
                <li><Link to="/faq" className="hover:text-primary transition-colors">FAQ</Link></li>
                <li><Link to="/changelog" className="hover:text-primary transition-colors">Changelog</Link></li>
              </ul>
            </div>
            <div>
              <h5 className="font-bold text-xs uppercase tracking-widest mb-3">Hukum</h5>
              <ul className="space-y-2 text-sm text-muted-foreground">
                <li><Link to="/terms" className="hover:text-primary transition-colors">Syarat & Ketentuan</Link></li>
                <li><Link to="/privacy" className="hover:text-primary transition-colors">Kebijakan Privasi</Link></li>
              </ul>
            </div>
            <div>
              <h5 className="font-bold text-xs uppercase tracking-widest mb-3">Komunitas</h5>
              <ul className="space-y-2 text-sm text-muted-foreground">
                {platformConfig?.instagram_url && (
                  <li><a href={platformConfig.instagram_url} target="_blank" rel="noreferrer" className="hover:text-primary transition-colors">Instagram</a></li>
                )}
                {platformConfig?.discord_url && (
                  <li><a href={platformConfig.discord_url} target="_blank" rel="noreferrer" className="hover:text-primary transition-colors">Discord</a></li>
                )}
                {platformConfig?.youtube_url && (
                  <li><a href={platformConfig.youtube_url} target="_blank" rel="noreferrer" className="hover:text-primary transition-colors">YouTube</a></li>
                )}
                {platformConfig?.facebook_url && (
                  <li><a href={platformConfig.facebook_url} target="_blank" rel="noreferrer" className="hover:text-primary transition-colors">Facebook</a></li>
                )}
              </ul>
            </div>
          </div>
          <div className="border-t-2 border-foreground/10 pt-6 text-center">
            <p className="font-display font-bold text-lg">Traktirkan © {new Date().getFullYear()}</p>
            <p className="text-sm text-muted-foreground mt-1">Dibuat dengan ❤️ untuk kreator Indonesia.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
